import { Box, Flex, Grid, IconButton, Image, Text, Button, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, FormControl, FormLabel, Input, Select, FormErrorMessage, } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import MyDiv from "./eductionalDetails.style";
import EductionalLogo from "../../../../../assets/images/EductionalLogo.svg";
import EditLogo from "../../../../../assets/images/EditLogo.svg";
import { CustomButton, CustomToast } from "../../../../../components";
import { useFetch } from "../../../../../hooks/useFetch";
import { CategoryDD, DegreeDD, EducationDetailHeaders, EductionalDetailModel, IEducationDetail, Props, EducationSchema } from "./model";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../../../../hooks/useAuth";

const EductionalDetails = ({ employeeId }: Props) => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isAddMode, setIsAddMode] = useState<boolean>(false);
  const [educationData, setEducationData] = useState<EductionalDetailModel[]>([]);
  const [educationCategory, setEductionCategory] = useState<CategoryDD[]>([]);
  const [educationDegree, setEductionDegree] = useState<DegreeDD[]>([]);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const { hasPermission, loginObj } = useAuth();

  const loggedInEmployeeId = loginObj?.employeeId;

  const isOwnProfile = employeeId === loggedInEmployeeId;

  const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IEducationDetail>({
    resolver: yupResolver(EducationSchema as any),
    defaultValues: {
      education_Category_Id: 0,
      education_Degree_Id: 0,
      isCourseStream: false,
      course: "",
      instituteName: "",
      grade: "",
      passingYear: "",
    },
  });

  async function loadEducationDetail() {
    const response = await fetchApi("Hrlense_Employee/educationDetails", "GET", null, `employeeId=${employeeId}`, "");
    if (response) setEducationData(response);
  }

  const Education_Cat = async () => {
    const response = await fetchApi("Hrlense_EducationCategories", "GET", null, "", "");
    if (response) setEductionCategory(response);
  };

  const Education_Degree = async (categoryId: number) => {
    const response = await fetchApi("dropdown/EduDegrees", "GET", null, `educationCategoryId=${categoryId}`, "");
    if (response) setEductionDegree(response);
  };

  useEffect(() => {
    if (employeeId) {
      loadEducationDetail();
      Education_Cat();
    }
  }, [employeeId]);

  const selectedCategory = watch("education_Category_Id");
  const selectedDegree = watch("education_Degree_Id");
  const selectedDegreeData = educationDegree.find(x => x.id === Number(selectedDegree));
  useEffect(() => {
    if (selectedCategory) {
      Education_Degree(selectedCategory);
    }
  }, [selectedCategory]);


  useEffect(() => {
    if (selectedDegreeData) {
      setValue(
        "isCourseStream",
        selectedDegreeData.isCourseStream ?? false
      );

      if (!selectedDegreeData.isCourseStream) {
        setValue("course", "");
      }
    }
  }, [selectedDegreeData, setValue]);
  const handleEditClick = (record: EductionalDetailModel) => {
    setIsAddMode(false);
    setSelectedId(record.id);

    reset({
      education_Category_Id: record.education_Category_Id,
      education_Degree_Id: record.education_Degree_Id,
      course: record.course,
      instituteName: record.university,
      grade: record.grade,
      passingYear: record.passingYear ? record.passingYear.split("T")[0] : "",
    });

    setDrawerOpen(true);
  };

  const handleAddClick = () => {
    setIsAddMode(true);
    setSelectedId(null);
    reset({
      education_Category_Id: 0,
      education_Degree_Id: 0,
      isCourseStream: false,
      course: "",
      instituteName: "",
      grade: "",
      passingYear: "",
    });
    setDrawerOpen(true);
  };

  const onSubmit = async (formData: IEducationDetail) => {
    const payload = {
      EmployeeID: employeeId ?? undefined,
      Id: selectedId ?? 0,
      education_Category_Id: formData.education_Category_Id,
      education_Degree_Id: formData.education_Degree_Id,
      course: formData.course,
      instituteName: formData.instituteName,
      grade: formData.grade,
      passingYear: formData.passingYear,
    };

    if (isAddMode) {
      const response = await fetchApi("Hrlense_Employee/educationDetails", "POST", payload, null, "Education detail added successfully");
      if (response) {
        setDrawerOpen(false);
        loadEducationDetail();
      }
    } else {
      const response = await fetchApi(`Hrlense_Employee/educationDetails`, "PUT", payload, null, "Education detail updated successfully");
      if (response) {
        setDrawerOpen(false);
        loadEducationDetail();
      }
    }
  };

  return (
    <MyDiv>
      {educationData?.map((record, index) => (
        <Box key={index} pt={2} mb={6} className="main">
          <Flex justify="space-between" align="center" mb={2} pl={5} pr={5}>
            <Flex align="center" gap={3}>
              <Image src={EductionalLogo} alt="Edu Icon" />
              <Text className="font-poppins text_sm text_medium col">{record?.title}</Text>
            </Flex>
            {(hasPermission('Employee', 'UpdateEmployeesEductionalDetail') || (hasPermission('Employee', 'UpdateOwnEductionalDetail') && isOwnProfile)) && (<IconButton aria-label="Edit" icon={<Image src={EditLogo} />} variant="none" onClick={() => handleEditClick(record)} />)}
          </Flex>

          {EducationDetailHeaders.map((item, i) => (
            <Box key={i} py={2} px={10} bg="#FFFFFF" borderRadius={8} >
              <Grid templateColumns="1fr 1fr" alignItems="center" mb={2}>
                <Text className="font-poppins text_sm text_medium" color="rgba(102, 102, 102, 1)">{item.label}</Text>
                <Text className="font-poppins text_sm text_medium col">
                  {item.modifier
                    ? item.modifier(record[item.key as keyof EductionalDetailModel])
                    : record[item.key as keyof EductionalDetailModel]}
                </Text>
              </Grid>
            </Box>
          ))}
        </Box>
      ))}

      <Flex mt={6} pr={5} justifyContent="flex-end">

        {(hasPermission('Employee', 'AddEmployeesEductionalDetail') || (hasPermission('Employee', 'AddOwnEductionalDetail') && isOwnProfile)) &&
          (<CustomButton title="Add new Education Details" onClick={handleAddClick} className="font-poppins text_sm text_medium btn font_light btn_theme" />
          )}


      </Flex>

      {drawerOpen && (
        <Drawer isOpen={drawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="md">
          <DrawerOverlay />
          <form onSubmit={handleSubmit(onSubmit)}>
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerHeader>{isAddMode ? "Add New Education Detail" : "Edit Education Detail"}</DrawerHeader>
              <DrawerBody pb="80px">
                <FormControl mb={4} isInvalid={!!errors.education_Category_Id} isRequired>
                  <FormLabel>Category</FormLabel>
                  <Controller
                    name="education_Category_Id"
                    control={control}
                    render={({ field }) => (
                      <Select placeholder="Select Category" {...field}>
                        {educationCategory.map((cat) => (
                          <option key={cat.id} value={cat.id}>
                            {cat.educationName}
                          </option>
                        ))}
                      </Select>
                    )}
                  />
                  <FormErrorMessage>{errors.education_Category_Id?.message}</FormErrorMessage>
                </FormControl>

                <FormControl mb={4} isInvalid={!!errors.education_Degree_Id} isRequired>
                  <FormLabel>Degree</FormLabel>
                  <Controller
                    name="education_Degree_Id"
                    control={control}
                    render={({ field }) => (
                      <Select placeholder="Select Degree" {...field}>
                        {educationDegree.map((deg) => (
                          <option key={deg.id} value={deg.id}>
                            {deg.degreeName}
                          </option>
                        ))}
                      </Select>
                    )}
                  />
                  <FormErrorMessage>{errors.education_Degree_Id?.message}</FormErrorMessage>
                </FormControl>

                {selectedDegreeData?.isCourseStream && (
                  <FormControl mb={4} isInvalid={!!errors.course} isRequired>
                    <FormLabel>Course/Stream</FormLabel>
                    <Controller
                      name="course"
                      control={control}
                      render={({ field }) => (
                        <Input
                          placeholder="Enter Course/Stream"
                          {...field}
                        />
                      )}
                    />
                    <FormErrorMessage>{errors.course?.message}</FormErrorMessage>
                  </FormControl>
                )}

                <FormControl mb={4} isInvalid={!!errors.instituteName} isRequired>
                  <FormLabel>Institute/University</FormLabel>
                  <Controller
                    name="instituteName"
                    control={control}
                    render={({ field }) => <Input placeholder="Enter Institute/University" {...field} />}
                  />
                  <FormErrorMessage>{errors.instituteName?.message}</FormErrorMessage>
                </FormControl>

                <FormControl mb={4} isInvalid={!!errors.grade} isRequired>
                  <FormLabel>Percentage/CGPA</FormLabel>
                  <Controller
                    name="grade"
                    control={control}
                    render={({ field }) => (
                      <Input
                        {...field}
                        type="text"
                        placeholder="Enter Percentage (0–100) or CGPA (0–10)"
                        onChange={(e) => {
                          let val = e.target.value;
                          if (!/^\d*\.?\d{0,2}$/.test(val)) return;
                          if (/^\d{4,}/.test(val)) return;
                          field.onChange(val);
                        }}
                      />
                    )}
                  />
                  <FormErrorMessage>{errors.grade?.message}</FormErrorMessage>
                </FormControl>

                <FormControl mb={4} isInvalid={!!errors.passingYear} isRequired>
                  <FormLabel>Passing Year</FormLabel>
                  <Controller
                    name="passingYear"
                    control={control}
                    render={({ field }) => (
                      <Select
                        placeholder="Select Passing Year"
                        value={field.value ? field.value.split("-")[0] : ""}
                        onChange={(e) => {
                          const year = e.target.value;
                          field.onChange(`${year}-01-01`);
                        }}
                      >
                        {Array.from({ length: 50 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </Select>
                    )}
                  />
                  <FormErrorMessage>{errors.passingYear?.message}</FormErrorMessage>
                </FormControl>
              </DrawerBody>

              <Box position="fixed" bottom="24px" right="24px">
                <Button className="btn_theme" type="submit">{isAddMode ? "Add Detail" : "Update Detail"}</Button>
              </Box>
            </DrawerContent>
          </form>
        </Drawer>
      )}
    </MyDiv>
  );
};

export default EductionalDetails;
